import React, { memo } from 'react';
import classNames from 'classnames';
import './CheckMark.scss';

interface Props {
    type?: 'radio' | 'checkbox',
    id?: string,
    name?: string,
    label?: string,
    isChecked?: boolean,
    isDisabled?: boolean,
    hasContainer?: boolean,
    value?: string,
    onCheckMarkChange?: ((event: React.ChangeEvent<HTMLInputElement>) => void) | undefined,
}

const CheckMark: React.FC<Props> = ({
  type = 'checkbox', id = String(Date.now()), name = '', label = '', isChecked = false, isDisabled = false, hasContainer = false, onCheckMarkChange = () => {}, value = '',
}): JSX.Element => {
  const classes = classNames({
    'nw-checkmark': true,
    'nw-checkmark--has-label': label,
    'nw-checkmark--disabled': isDisabled,
    'nw-checkmark--has-container': hasContainer,
  });
  return (
    <div className={classes}>
      <label
        htmlFor={id}
      >
        <input
          id={id}
          type={type}
          name={name}
          className="nw-checkmark__input"
          checked={isChecked}
          disabled={isDisabled}
          value={value}
          onChange={onCheckMarkChange}
        />
        <span className={`nw-checkmark__container ${!label ? 'nw-checkmark__container--no-label' : ''}`}>
          <span className="nw-checkmark__switcher" />
          {label
              && <span className="nw-checkmark__label">{label}</span>}
        </span>
      </label>
    </div>
  );
};

export default memo(CheckMark);
